import React, { Component } from "react";

import { FirebaseProducts, firebase } from "../../firebase";

import { firebaseLooper } from "../ui/misc";

import ProductCard from "../ui/ProductCard";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";

import { TabContainer } from "../ui/misc";
import { CircularProgress } from "@material-ui/core";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import {Helmet} from "react-helmet";

const styles = theme => ({
  tabsIndicator: {
    backgroundColor: "#ffffff"
  },
  ButtonStyle: {
    borderColor: "#005f9c",
    color: "#005f9c",
    "&:hover": {
      borderColor: "#005f9c"
    }
  }
});

class Najivki extends Component {
  state = {
    isLoading: true,
    products: [],
    categories: this.props.location.state.categories,
    selected: this.props.location.state.selected,
    value: 5
  };

  componentDidMount() {
    FirebaseProducts
      .orderByChild('product')
      .equalTo(this.state.selected)
      .once("value")
      .then(snapshot => {
        const products = firebaseLooper(snapshot);
        let promises = []

        for(let key in products){
          promises.push(
            new Promise((resolved, reject) => {
              firebase.storage().ref('product')
              .child(products[key].image)
              .getDownloadURL()
              .then((url) => {
                products[key].url = url;
                resolved();
              })
            })  
          )
        }

        Promise.all(promises).then(() => {
          this.setState({
            isLoading: false,
            products
          })
        })
        
      });

    setTimeout(() => {
      this.setState({
        isLoading: false
      });
    }, 1000);
  }

  changeState = (selected, value, categories) => {
    this.setState({
      selected,
      isLoading: true
    });

    this.changeProduct(selected, value, categories);
  };

  changeProduct = (selected, value, categories) => {
    this.props.history.push({
      pathname: `/products/${selected}`,
      state: {value, selected, categories}
    })

    this.setState({
      products: [],
      categories: [],
      value: -1
    })
  };

  showAllProducts = (products, user) =>
    products.map((product, i) => (
      <React.Fragment key={i}>
        <ProductCard
          image={product.url}
          title={product.title}
          desc={product.desc}
          linkTo={product.id}
          price={product.price}
          key={product.id}
          isInStore={product.isInStore}
          user={user}
          product={product}
          brand={product.brand}
        />
      </React.Fragment>
    ));

  handleChange = (event, value) => {
    this.setState({ value });
  };

  showTabs = categories => {
    categories.map(categorie => <TabContainer>{categorie.id}</TabContainer>);
  };

  handleAddProduct = (product) => {
    this.props.history.push({
      pathname: `${product}/add`,
      state: {product}
    })
  }


  render() {
    const { classes, user } = this.props;
    return (
      <div id="all_products">
      <Helmet>
          <meta charSet="utf-8" />
          <link rel="shortcut icon" type="image/png" href="/public/Icon.png" />
          <title>Планета Рыбака - Наживки</title>
          <link
            rel="canonical"
            href="https://rybalka-md.com"
          />
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta
            name="description"
            content="Магазин рыболовных изделий в Молдове, Кишинёв, улица Alba-Iulia 198 ger.34/1, рынок 'Дельфин'. Тут вы найдёте удилища, кутушки, снасти, прикормки, наживки, приманки, подставки, подсаки, сумки, одежда, снаряжения и другое, всё для рыбалки."
          />
          <meta property="og:url" content="https://rybalka-md.com/products/Наживки" />
        </Helmet>
        <div
          className="products_list"
          style={{
            flexGrow: "1"
          }}
        >
          <AppBar
            position="static"
            style={{
              backgroundColor: "#005f9c"
            }}
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              style={{
                display: "flex",
                justifyContent: "space-evenly"
              }}
              classes={{ indicator: classes.tabsIndicator }}
            >
              {this.state.categories.map(categorie => (
                <Tab
                  className="all_products_tab"
                  style={{
                    maxWidth: "120px",
                    minWidth: "120px"
                  }}
                  label={categorie.id}
                  key={categorie.id}
                  onClick={() => this.changeState(categorie.id, this.state.value, this.state.categories)}
                />
              ))}
            </Tabs>
          </AppBar>

          <h1 className="all_products_title">{this.state.selected}</h1>

          <div className="container">
          {user ? (
            <span
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginRight: "150px"
              }}
            >
              <Button
                variant="outlined"
                size="medium"
                color="primary"
                className={classNames(classes.ButtonStyle)}
                onClick={() => this.handleAddProduct(this.state.selected)}
              >
                <AddIcon />
                Добавить
              </Button>
            </span>
          ) : null}

          {this.showTabs(this.state.categories)}
        </div>
        {this.state.isLoading ? (
          <div className="all_products_progress">
            <CircularProgress
              style={{
                color: "#38726f"
              }}
              thickness={5}
            />
          </div>
        ) : (
            <div className="products">
              {this.showAllProducts(this.state.products, this.props.user)}
            </div>
        )}
        </div>
      </div>
    );
  }
}

Najivki.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Najivki);
